<template>
  <div>
    <h1 class="subtitle">{{ pdfFileName }}</h1>
    <pdf
      v-if="pdf"
      :src="pdfUrl"
      :page="currentPageNum"
      :scale.sync="scale"
      @numpages="getNumPages"
      style="width:100%;margin:20px auto;border-color:black;border-width:2px;border-style:dashed;">
      <template slot="loading">
        loading content here...
      </template>
    </pdf>
    <nav class="level pdf-viewer-buttons">
      <div class="level-item has-text-centered">
        <button type="button" class="button is-primary" :disabled="disablePreviousButton" @click="goToPreviousPage">
          <span class="icon">
            <i class="mdi mdi-step-backward"></i>
          </span>
          <span>Previous</span>
        </button>
      </div>
      <div class="level-item has-text-centered">
        {{ currentPageNum }} / {{ numPages ? numPages : '∞' }}
      </div>
      <div class="level-item has-text-centered">
        <button type="button" class="button is-primary" :disabled="disableNextButton" @click="goToNextPage">
          <span>Next</span>
          <span class="icon">
            <i class="mdi mdi-step-forward"></i>
          </span>
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import pdf from 'pdfvuer'

export default {
  name: 'pdfViewer',
  components: {
    pdf
  },
  props: {
    pdfId: {
      type: String,
      default: ''
    }
  },
  async created () {
    await this.$store.dispatch('loadPdf', {
      id: this.pdfId
    })
  },
  data: () => ({
    numPages: null,
    page: 1,
    scale: 'page-width'
  }),
  methods: {
    getNumPages (numPages) {
      this.$store.dispatch('updatePdf', {
        numPages
      })
      this.numPages = numPages
    },
    goToPreviousPage () {
      this.page--
      this.$store.dispatch('updateUserPdf', {
        currentPageNum: this.currentPageNum - 1
      })
    },
    goToNextPage () {
      this.page++
      this.$store.dispatch('updateUserPdf', {
        currentPageNum: this.currentPageNum + 1
      })
    }
  },
  computed: {
    currentPageNum () {
      return this.$store.getters.getCurrentPageNum
    },
    disablePreviousButton () {
      return this.currentPageNum === 1
    },
    disableNextButton () {
      return this.currentPageNum === this.numPages
    },
    pdf () {
      return this.$store.getters.getPdf
    },
    pdfFileName () {
      if (this.pdf) {
        return this.pdf.fileName
      }
      return ''
    },
    pdfUrl () {
      if (this.pdf) {
        return this.pdf.url
      }
      return ''
    }
  },
  destroyed () {
    this.$store.dispatch('resetPdf')
  }
}
</script>

<style scoped>
  .pdf-viewer {
    border-color: black;
  }
  .pdf-viewer-buttons {
    margin: 30px;
  }
</style>
